import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { Form, Formik } from 'formik';
import classNames from 'classnames';
import history from '../../store/history';
import { CLEAR_LOADING, SET_LOADING } from '../../actions/utils';
import TextField from '../../components/share/TextField';
import { notEmpty } from '../../components/share/utils';

const ForgetPassword = () => {
  const initialValue = { username: '', email: '' };

  const [message, setMessage] = useState('');
  const [error, setError] = useState(false);

  let showMessage = '';
  let dispatch = useDispatch();

  const onSubmit = async (values) => {
    try {
      dispatch({ type: SET_LOADING });
      let csrfResponse = await axios.get('/csrf');
      const { token, headerName } = csrfResponse.data;
      let headers = { [headerName]: token };
      await axios.post('/api/forget-password', values, headers);
      setError(false);
      showMessage = 'Mật khẩu đã được gởi đến email của bạn';
    } catch (error) {
      setError(true);
      showMessage = 'Tên đăng nhập hoặc email không hợp lệ.';
    } finally {
      setMessage(showMessage);
      dispatch({ type: CLEAR_LOADING });
    }
  };

  return (
    <div className='container'>
      <Formik initialValues={initialValue} onSubmit={onSubmit}>
        {(props) => (
          <Form className='mt-3'>
            <fieldset>
              <legend className='text-primary'>Khôi phục mật khẩu</legend>
              {message ? (
                <span className={classNames('form-text', { 'text-danger': error, 'text-success': !error })}>
                  {message}
                </span>
              ) : null}
              <div className='row'>
                <TextField name='email' label='Tên đăng nhập hoặc Email' validate={notEmpty} required />
              </div>
            </fieldset>
            <div className='row'>
              <div className='d-flex justify-content-between col-md-6'>
                <button className='btn btn-outline-primary' type='button' onClick={() => history.push('/')}>
                  Trang chủ
                </button>
                <button className='btn btn-primary' disabled={props.isSubmitting || !props.isValid}>
                  Gửi
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};
export default ForgetPassword;
